import FilesPage from '@/routes/dashboard/files/FilesPage'
import { FilesExperienceRedirect } from './filesExperienceRedirect'
import type { RouteFactory } from '../../types'

/**
 * Creates files routes for nesting under MatterLayout.
 * URL pattern: /dashboard/m/:matterId/files/:driveName/*
 *
 * Note: Authentication is handled by MatterLayout's AnonFeatureGuard,
 * so no additional AnonymousGuard wrapper is needed here.
 *
 * @see MatterLayout for parent route context
 */
export const createFilesChildRoutes: RouteFactory = () => [
  {
    // Redirects to the new user-files experience when it's enabled; renders the legacy drive otherwise.
    element: <FilesExperienceRedirect experience="legacy" />,
    children: [
      {
        path: 'files/:driveName/*',
        element: <FilesPage />,
      },
    ],
  },
]
